import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../../../Layout/Loader';
import { Navigate } from 'react-router-dom';
import { Alert } from 'reactstrap';
import UserDataOnDemand from '../../../ApolloConnectors/UserData/UserDataConnectorApollo';
import { withTranslator } from '../../../I18n/withTranslator';
import setAuthCredentials from '../../setAuthCredentials';
import RegisterViaGoogleConnectorApollo from './Connector/Apollo/RegisterViaGoogleConnectorApollo';
import AuthRegisterByGoogleTokenWrapperComponent from './AuthRegisterByGoogleTokenWrapperComponent';
import { RETURN_URL_REGISTER } from '../../Login/ByExternalProvider/LoginReturnUrls';
import withAppContext from '../../../AppContext/withAppContext';

class AuthRegisterByGoogleTokenComponent extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    returnUrl: PropTypes.string,
  };

  static defaultProps = {
    returnUrl: RETURN_URL_REGISTER,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      errors: [],
    };
  }

  registerViaGoogle = async (registerViaGoogle, userDataOnDemand) => {
    const response = await registerViaGoogle;

    if (response.data.auth.registerViaGoogle.__typename === 'OauthException') {
      if (response.data.auth.registerViaGoogle.code === 400) {
        this.setState((prevState) => ({
          errors: [...prevState.errors, this.props.t('auth/login/user-exists')],
        }));
      }
    } else {
      const userToken = response.data.auth.registerViaGoogle.token;
      setAuthCredentials(userToken);
      await userDataOnDemand();
    }

    this.setState({ isLoading: false });
  };

  render() {
    const error = new URL(document.location.href).searchParams.get('error');
    const token = new URL(document.location.href).searchParams.get('code');
    const state = new URL(document.location.href).searchParams.get('state');
    let returnPath = '/cart';

    if (state === 'stripe') {
      returnPath = '/buy';
    } else if (state === 'auth_register') {
      returnPath = '/';
    } else if (state === 'cart_register') {
      returnPath = '/cart/save-payment';
    } else if (state === 'activate_product_register') {
      returnPath = '/coupon/access-code';
    } else if (state === 'activate_product_register_nutropharma') {
      returnPath = '/coupon-nutropharma/access-code';
    }

    if (error) {
      return <Navigate to={returnPath} />;
    }

    return (
      <React.Fragment>
        {this.state.errors.map((msg) => (
          <Alert color="danger" key={msg}>
            {msg}
          </Alert>
        ))}
        <RegisterViaGoogleConnectorApollo>
          {(result) => (
            <UserDataOnDemand>
              {(result2) => (
                <AuthRegisterByGoogleTokenWrapperComponent
                  registerViaGoogle={() =>
                    this.registerViaGoogle(
                      result.registerViaGoogle(token, this.props.returnUrl),
                      result2.userDataOnDemand
                    )
                  }
                />
              )}
            </UserDataOnDemand>
          )}
        </RegisterViaGoogleConnectorApollo>
        {this.state.isLoading ? (
          <div className="full-height">
            <Loader />
          </div>
        ) : null}

        {!this.state.isLoading && !this.state.errors.length ? <Navigate to={returnPath} /> : null}
      </React.Fragment>
    );
  }
}

export default withAppContext(withTranslator(AuthRegisterByGoogleTokenComponent));
